import React from 'react';
import PropTypes from 'prop-types';
import { colors } from './../../assets/theme';
import Dotdotdot from 'react-dotdotdot'

class ItemSubTitle extends React.Component {   

    constructor(props){
        super(props);
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){
        if(!this.props.content) return null;
       
        const getText = ()=>{
            if(this.props.truncate){
                return (
                    <Dotdotdot clamp={1}>
				        <p>{this.props.content}</p>
			        </Dotdotdot>
                )
            } else {
                return  <p>{this.props.content}</p> 
            }
        }
        return (
            <div className="ItemSubTitle">
                {getText()}
                <style jsx>{`
                    .ItemSubTitle {
                        font-size:14px;
                        margin:0;  
                        white-space: ${(this.props.truncate)?'inherit': 'pre-line'};
                        font-weight: 400;                  
                        transition: all 0.3s;
                        color: ${colors.dark}
                    }


                    
                `}</style>
                
                    
            </div>
        )
    }
}

ItemSubTitle.propTypes = {
    truncate : PropTypes.number,
    content : PropTypes.string
}

export default ItemSubTitle;


// WEBPACK FOOTER //
// ./src/components/common/ItemSubTitle.js